<template>
  <div class="hd-search">
    <div class="search-cont">
      <div class="search-cont-inside">
        <input
          v-model="keyWords"
          placeholder="搜索你喜欢的游戏"
          type="text"
          @focus="isFocus = true"
          @blur="inputBlur"
          @keyup.enter.prevent="startSearch"
        />
        <div
          class="search-btn"
          @click="
            startSearch()
            $util.clickStat(`GWSY/TAGSSAN`, `官网首页/标签栏搜索按钮`)
          "
        >
          <img src="../../../assets/img/common/search_icon_01.png" alt="" />
        </div>
      </div>
      <!-- 搜索结果 -->
      <div v-show="toggleRsultModule" class="reslut-content">
        <template v-if="keyWords">
          <div v-for="(g, i) in fSearch" :key="i" class="reslut-list3">
            <div class="game-avatar"><img :src="g.img_url" alt="" /></div>
            <div class="game-info">
              <div class="game-name text-ellipsis">{{ g.title }}</div>
              <div class="game-option">
                <div class="start-game" @click="startGame(g, i)">进入游戏</div>
                <div
                  class="official-website"
                  @click="
                    visitWebsite(g)
                    $util.clickStat(
                      `GWSY/TAGSSYX${i + 1}/GW`,
                      `官网首页/标签栏搜索游戏${i + 1}/官网`
                    )
                  "
                >
                  官网
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(g, i) in gameList" :key="i" class="reslut-list3">
            <div class="game-avatar"><img :src="g.img_url" alt="" /></div>
            <div class="game-info">
              <div class="game-name text-ellipsis">{{ g.title }}</div>
              <div class="game-option">
                <div class="start-game" @click="startGame(g, i)">进入游戏</div>
                <div
                  class="official-website"
                  @click="
                    visitWebsite(g)
                    $util.clickStat(
                      `GWSY/TAGSSYX${i + 1}/GW`,
                      `官网首页/标签栏搜索游戏${i + 1}/官网`
                    )
                  "
                >
                  官网
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      isFocus: false,
      keyWords: '',
      gameList: [],
      gameList2: []
    }
  },
  computed: {
    fSearch() {
      if (this.keyWords) {
        return this.gameList2.filter((val) => {
          return val.title.includes(this.keyWords)
        })
      } else {
        return ''
      }
    },
    toggleRsultModule() {
      let status = false
      if (!this.isFocus) {
        return status
      }
      if (this.keyWords === '' || this.fSearch.length > 0) {
        status = true
      }
      return status
    }
  },
  created() {
    this.$request('allGameSearch').then((data) => (this.gameList = data || []))
    this.getGameList()
  },
  mounted() {
    this.getGameList()
  },
  methods: {
    // 处理失去焦点无法点击候选项
    inputBlur() {
      setTimeout(() => {
        this.isFocus = false
      }, 249)
    },
    // 点搜索按钮
    startSearch() {
      if (!this.keyWords) {
        return false
      }
      this.$router.push({
        path: 'all-game',
        query: { key_words: this.keyWords }
      })
      this.$store.commit('allGame/setSearchName', this.keyWords)
    },
    // 进入游戏
    startGame(g, i) {
      this.inputBlur()
      this.$util.gameStat(
        g.game_id,
        g.server_list[0].server_id,
        `GWSY/TAGSSYX${i + 1}/JRYX`,
        `官网首页/标签栏搜索游戏${i + 1}/进入游戏`
      )
    },
    // 访问官网
    visitWebsite(g) {
      this.inputBlur()
      const _url = 'game-offical/' + g.game_id
      const routeUrl = this.$router.resolve({
        path: _url
      })
      console.log(_url)
      window.open(routeUrl.href, '_blank')
      // this.$router.push(_url);
    },
    // 实时搜搜
    getGameList() {
      this.$request('cateServerList').then(
        (data) => (this.gameList2 = data || [])
      )
    }
  }
}
</script>

<style src="~/assets/css/h_search.css"></style>
